module.exports = __webpack_public_path__ + "static/media/ExtremelyPatient.d0974f4b.png";